<script lang="ts">
  import { getStr, globalCurrencyTag } from '../../../../common/util';
  import ExtraButton from '../../../common/components/ExtraButton.svelte';
  import Icon from '../../../common/components/Icon.svelte';
  import ProductConditionTag from '../../../common/components/ProductConditionTag.svelte';
  import Text from '../../../common/components/Text.svelte';

  export let offer;
  export let activeGroup;
  export let tabConfig;
  export let onAddToCart: (offerId?: any, quantity?: any) => void = () => {};
  export let hoveredTooltip = null;
  export let onTooltipHover: (offerId?: any) => void = () => {};
  export let onTooltipLeave: () => void = () => {};
  export let giftItem;
  const hasGiftItem = typeof giftItem !== 'undefined' && giftItem?.length > 0;
</script>

<div class="seller-card">
  <div class="seller-card-top">
    <div class="price-block">
      {#if tabConfig[activeGroup.conditionCode]?.image}
        <!-- <img src={tabConfig[activeGroup.conditionCode].image} alt={offer.state} class="seller-image" /> -->
        <ProductConditionTag condition={activeGroup.conditionCode} />
      {/if}

      <span class="seller-price">
        {@html getStr('jood.price.with.currency', [
          globalCurrencyTag,
          offer.discountPrice?.value || offer.price?.value,
        ])}
      </span>
    </div>

    <ExtraButton
      color="primary"
      size="small"
      variant="solid"
      on:click={() => onAddToCart(offer.id, offer.minOrderQuantity)}
    >
      <Text key="extra.addtocartbutton" />
    </ExtraButton>
  </div>

  <div class="seller-card-body">
    <div class="seller-line">
      <div class="line-label">
        <Icon glyph="icon-box" type="primary" mobileSize={14} desktopSize={14} />
        <span><Text key="extra.marketplace.pdp.seller.sold.by.text" /></span>
      </div>

      <div class="line-description">
        <span class="shop-name">{offer.shopName}</span>
        <div class="separator-horizontal hide-on-mobile"></div>
      </div>
    </div>

    <div class="separator-horizontal hide-on-desktop"></div>
    <div class="seller-line">
      <div class="line-label">
        <Icon glyph="icon-standard_delivery" type="primary" mobileSize={14} desktopSize={14} />
        <span><Text key="extra.marketplace.pdp.seller.delivery.text" /></span>
      </div>

      <div class="line-description">
        <span>
          {#if offer.earliestDeliveryDays && offer.latestDeliveryDays}
            <Text
              key="extra.marketplace.product.deliveryleadtime.label"
              args={[offer.earliestDeliveryDays, offer.latestDeliveryDays]}
            />
          {:else}
            <Text key="extra.marketplace.product.delivery.withoutdays" />
          {/if}
        </span>
        {#if activeGroup?.conditionCode !== 'NEW' && offer.state}
          <div class="separator-horizontal hide-on-mobile"></div>
        {/if}
      </div>
    </div>

    {#if activeGroup?.conditionCode !== 'NEW' && offer.state}
      <div class="separator-horizontal hide-on-desktop"></div>

      <div class="seller-line">
        <div class="line-label">
          <Icon glyph="icon-help" type="primary" mobileSize={14} desktopSize={14} />
          <span><Text key="extra.marketplace.pdp.seller.condition.text" /></span>

          <div
            class="tooltip-wrapper"
            on:mouseenter={() => onTooltipHover(offer.id)}
            on:mouseleave={() => onTooltipLeave()}
          >
            {#if hoveredTooltip === offer.id}
              <div class="tooltip">
                {@html getStr(tabConfig[activeGroup.conditionCode].tooltipLabelKey)}
              </div>
            {/if}
          </div>
        </div>

        <div class="line-description">
          <span>{offer.state}</span>

          {#if hasGiftItem}
            <div class="separator-horizontal hide-on-mobile"></div>
          {/if}
        </div>
      </div>
    {/if}
    {#if hasGiftItem}
      <div class="seller-line">
        <div class="line-label">
          <Icon type="png" desktopSize={14} mobileSize={14} glyph="gift" />
          <span><Text key="extra.offer.free.gift.text" /></span>
        </div>

        <div class="line-description gift-not-included">
          <span class="c_icon_new c_icon_new--close close-btn"></span>
          <span class="shop-name"><Text key="extra.offer.free.gift.not.included" /></span>
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .separator-horizontal {
    width: 298px;
    height: 1px;
    background-color: $secondary-gray-02;
    margin-top: 12px;
    @include desktop-max-width {
      margin-top: 0px;
    }
  }

  .seller-card {
    border-radius: 12px;
    border: 1px solid $neutral-light-03;
    margin-bottom: 24px;
    .seller-card-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $neutral-light-04;
      border-radius: 12px 12px 0 0;
      padding: 16px;

      .price-block {
        display: flex;
        flex-direction: column;
        gap: 5px;
        .seller-image {
          width: 56px;
          object-fit: contain;
        }
        .seller-price {
          font-size: 20px;
          line-height: 14px;
          font-weight: 700;
          color: $neutral-dark-01;
        }
      }
      :global(.extra-btn button) {
        width: fit-content;
        padding: 8px;
        font-size: 11px;
        line-height: 13px;
        font-weight: 700;
        white-space: nowrap;
      }
    }
    .seller-card-body {
      display: grid;
      gap: 12px;
      padding: 16px;

      .seller-line {
        display: flex;
        gap: 12px;
        .line-label {
          display: flex;
          gap: 4px;
          font-size: 12px;
          color: $neutral-dark-02;
          min-width: 119px;
        }
        .line-description {
          width: 148px;
          text-align: left;
          @include desktop-min-width {
            width: 298px;
          }
          span {
            font-size: 12px;
            line-height: 14px;
            color: $neutral-dark-01;
          }
          .shop-name {
            color: $tertiary-blue-03;
          }
          &.gift-not-included {
            .shop-name,
            .c_icon_new--close {
              color: #c4361b;
              line-height: 10px;
            }
          }
        }
      }
    }
  }

  .tooltip-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    &::after {
      content: 'i';
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #b8c4d0;
      color: $primary-white;
      font-size: 8px;
      cursor: pointer;
    }

    .tooltip {
      position: absolute;
      top: 50%;
      left: calc(100% + 12px);
      transform: translateY(-50%);
      width: 207px;
      padding: 10.5px;
      background: #20223a;
      color: $primary-white;
      border-radius: 5px;
      font-size: 10px;
      line-height: 10px;
      z-index: 1000;
      opacity: 1;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -8px;
        transform: translateY(-50%);
        border-width: 8px;
        border-style: solid;
        border-color: transparent #20223a transparent transparent;
        opacity: 1;
      }

      :global(a) {
        color: $primary-white;
        text-decoration: underline;
        font-weight: 400;
      }
    }
  }
</style>
